module.exports = __webpack_public_path__ + "img/17a003-15.10606df2.jpg";